// src/services/PusherService.js
import Pusher from "pusher-js";

const pusher = new Pusher("198bbc86418cb95a35a4", {
  cluster: "us2",
});

export const channel = pusher.subscribe("my-channel");
